var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-loader"},[_c('spaces-icon-primary',{staticClass:"app-loader__logo"}),_vm._v(" "),_c('div',{staticClass:"app-loader__loading-bar"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }